import {
  JobItem,
  JobTypeEnum,
  JobWorkflowStatusEnum,
} from 'domains/workspaceDomain';
import {
  FileItem,
  WorkspaceTabShippingBillingDTO,
} from 'domains/workspaceDetailDomain';
import { useMount } from 'ahooks';
import { newFileObject } from 'utils/misc';
import { useState } from 'react';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { CommonUploadFile } from '../../index';
import jobService from 'services/jobService';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'app/hooks';
import useJobCardInfo from 'features/Workspace/hooks/useJobCardInfo';

type Props = {
  jobData: JobItem;
  data?: WorkspaceTabShippingBillingDTO;
};
const InvoiceFiles = ({ jobData, data }: Props) => {
  const [defaultFileList, setDefaultFileList] = useState<FileItem[]>();
  const [fileLength, setFileLength] = useState(0);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const isInvoiced =
    jobData.workflowStatus === JobWorkflowStatusEnum.INVOICING ||
    (jobData.workflowStatus === JobWorkflowStatusEnum.COMPLETED &&
      jobData.jobType !== JobTypeEnum.INTERNAL);

  const { hasOperator, hasProducer } = useJobCardInfo(jobData);

  useMount(() => {
    const files: FileItem[] = [];
    if (data?.invoice?.supplierInvoiceReferenceFiles) {
      data.invoice.supplierInvoiceReferenceFiles.forEach((i) => {
        files.push(newFileObject(i.name, i.path, jobData.id));
      });
    }
    setDefaultFileList(files);
    setFileLength(files.length);
  });

  const deleteFileHandler = async (fileItem: FileItem) => {
    try {
      await dispatch.app.showLoading();
      await jobService.deleteInvoiceFile(jobData.id, {
        path: fileItem.path || fileItem.url,
      });
      return 'success';
    } catch {
      return '';
    } finally {
      await dispatch.app.hideLoading();
    }
  };

  return (
    // console.log('hasOperator', hasOperator),
    // console.log('hasProducer', hasProducer),
    <>
      {isInvoiced && (hasOperator || hasProducer) && (
        <div className="billing-info">
          <RevxFlexLayout className="title">
            {t('workspace.detail.po.supplierInvoice')}
          </RevxFlexLayout>
          <div className="common-billing-card-header-container invoice-upload-container">
            <CommonUploadFile
              showUploadButton={true}
              defaultFileList={defaultFileList}
              itemData={jobData}
              deleteFileHandler={fileLength > 1 ? deleteFileHandler : undefined}
              getAllFileHandler={dispatch.workspaceDetail.getAllFile}
              saveFileHandler={async (fileItem: FileItem) => {
                const { fileName, path } = fileItem;
                await jobService.saveInvoiceFile(fileItem.id, {
                  name: fileName,
                  path,
                });
                const file = newFileObject(fileName, path, jobData.id);
                return Promise.resolve(file);
              }}
              uploadIconBeforeOldFiles={false}
              getUploadFileList={(files) => {
                setFileLength(files.length);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceFiles;
